import moment from 'moment'
import { toast } from 'react-toastify';
import { utils, writeFile } from "xlsx";

export const fomateDate = (data) => {
  return moment(data).format('DD MMM YYYY')
}

export const formateDate = (data) => {
  return moment(data).format('MM/DD/YYYY')
}

export const formatefilDate = (data) => {
  return moment(data).format('YYYY/MM/DD')
}

export const formatesfilDate = (data) => {
  return moment(data).format('YYYY-MM-DD')
}

export const handleCopy = (text) => {
  navigator.clipboard.writeText(text).then(() => {
    toast.success('copied')
  }).catch(err => {
    toast.error('failed to copy')

  });
};


export const exportDataExcel = (data, title) => {
  const worksheet = utils.json_to_sheet(data); // Convert JSON to sheet
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, worksheet, title);
  writeFile(workbook, `${title}.xlsx`);
}



export const getDateRange = (period) => {
  const toDate = new Date();
  const fromDate = new Date();

  // Adjust the fromDate based on the period
  switch (period) {
    case "1day":
      fromDate.setDate(fromDate.getDate() - 1);
      break;
    case "7days":
      fromDate.setDate(fromDate.getDate() - 7);
      break;
    case "30days":
      fromDate.setDate(fromDate.getDate() - 30);
      break;
    case "12months":
      fromDate.setFullYear(fromDate.getFullYear() - 1);
      break;
    default:
      throw new Error("Invalid period specified");
  }
  return {
    from: formateDate(fromDate),
    to: formateDate(toDate),
  };
};

export const stripHtmlTags = (input) => {
  if (!input) return '';
  let str = Array.isArray(input) ? (input[0] || '') : input;
  if (typeof str !== 'string') str = String(str || '');
  return str
    .replace(/<\/(p|div|li|br)>/gi, ' ')
    .replace(/<br\s*[\/]?>/gi, ' ')
    .replace(/<[^>]*>?/gm, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&plusmn;/g, '±')
    .replace(/\s+/g, ' ')
    .trim();
};

export const getLeafCategoryName = (categories) => {
  if (!Array.isArray(categories) || categories.length === 0) return '';
  const lastCat = categories[categories.length - 1];
  return lastCat?.name || (typeof lastCat === 'string' ? lastCat : '');
};